module.exports = __webpack_public_path__ + "img/dashboard.d4dffbdd.svg";